import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "../../../Axios";
import "./freeCourse.scss";

const noFile = require("../../../assets/no-file.png");
const noIMG = require("../../../assets/no-image.png");
const avatarFallback = require("../../../assets/teacher.jpg")

const FreeCourse = () => {
  const [freeCourses, setFreeCourses] = useState([]);
  const [paidCourses, setPaidCourses] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [freeRes, paidRes] = await Promise.all([
          Axios.get("/courses/1/list"), // FREE
          Axios.get("/courses/0/list"), // PAID
        ]);

        if (Array.isArray(freeRes.data)) {
          setFreeCourses(freeRes.data.slice(0, 3));
        }

        if (Array.isArray(paidRes.data)) {
          setPaidCourses(paidRes.data.slice(0, 3));
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  const renderStars = () => (
    <div className="freeCourse__stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={i === 4 ? "is-muted" : ""}>★</span>
      ))}
    </div>
  );

  const renderCards = (courses = [], badgeText = "Үнэгүй хичээл") => (
    <div className="freeCourse__grid">
      {courses.map((item, idx) => (
        <Link
          to={`/courses/${item.id}`}
          key={idx}
          className="freeCourse__card"
        >
          <div className="freeCourse__cardImageWrap">
            <img
              src={item.cover || noIMG}
              alt={item.title || "course"}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noFile;
              }}
              className="freeCourse__cardImage"
            />
          </div>

          <div className="freeCourse__cardBody">
            <div className="freeCourse__metaRow">
              <span className="freeCourse__metaText">{badgeText}</span>
              {renderStars()}
            </div>

            <h4 className="freeCourse__cardTitle">
              {item.title || "Хичээлийн нэр"}
            </h4>
          </div>

          <div className="freeCourse__cardFooter">
            <div className="freeCourse__teacher">
              <img
                src={item.teacher_image || avatarFallback}
                alt="teacher"
                className="freeCourse__teacherAvatar"
              />
              <div className="freeCourse__teacherInfo">
                <div className="freeCourse__teacherName">
                  {item.teacher_name || "Баярсайхан Пүрэв-Очир"}
                </div>
                <div className="freeCourse__teacherRole">Багш</div>
              </div>
            </div>

            <div className="freeCourse__cardButton">Үзэх</div>
          </div>
        </Link>
      ))}
    </div>
  );

  return (
    <section className="freeCourse">
      <div className="freeCourse__panel">
        <div className="freeCourse__header">
          <h2>Хичээлүүд</h2>
        </div>

        {/* FREE */}
        <div className="freeCourse__section">
          <div className="freeCourse__sectionHeader">
            <h3><span>ТӨЛБӨРГҮЙ</span> Сургалт</h3>
            <p>
              Төлбөргүй сургалтаар дамжуулан та зах зээлийн хөдөлгөөн, арилжааны
              суурь зарчим болон сэтгэлзүйн үндсийг цэгцтэй ойлгож, дараагийн
              түвшинд гарах бэлтгэлээ бүрдүүлнэ.
            </p>
          </div>
          {renderCards(freeCourses, "Үнэгүй хичээл")}
        </div>

        {/* PAID */}
        <div className="freeCourse__section freeCourse__section--paid">
          <div className="freeCourse__sectionHeader">
            <h3><span>ТӨЛБӨРТЭЙ</span> Сургалт</h3>
            <p>
              OCHIROO&apos;S THEORY шинжилгээг бүрэн эзэмшиж, зах зээлийг зөв
              системтэй уншиж сурахын зэрэгцээ, өөрийн арилжааны ур чадварыг
              дараагийн шатанд гаргана.
            </p>
          </div>
          {renderCards(paidCourses, "Төлбөртэй хичээл")}
        </div>
      </div>
    </section>
  );
};

export default FreeCourse;
